// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-left"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11 6.5L5.5 12L11 17.5M6.75 12H19.75","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowLeftIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-left',
    ref,
    icon: element,
  },
));

ArrowLeftIcon.displayName = 'ArrowLeftIcon';

export default ArrowLeftIcon;
